
const API_URLS = {
    retrieveEmailLambda: 'https://dee1aci233.execute-api.us-east-1.amazonaws.com/prod/',
    submitEmailLambda: 'https://wpph2l67ma.execute-api.us-east-1.amazonaws.com/prod/',
    processMessageLambda: 'https://gs0s8l92d2.execute-api.us-east-1.amazonaws.com/prod'
};

export default API_URLS;